import * as types from './types';
import { createCoverageReducers } from '../../../common/coverage/reducers';
import { VdcOSCoverageRecord } from '../../../../records';

const { initialState, reducer } = createCoverageReducers({
  types,
  CoverageRecord: VdcOSCoverageRecord,
});

export default reducer;
export { initialState };
